import { adminBorders, adminColors, adminRadii, adminTransitions } from '../theme/adminTokens'

export const FORM_PANEL_SX = {
    p: 2,
    borderRadius: `${adminRadii.control}px`,
    borderColor: adminBorders.subtle,
    backgroundColor: 'background.paper',
}

export const FORM_SUB_PANEL_SX = {
    p: 1.5,
    height: '100%',
    borderRadius: `${adminRadii.control}px`,
    border: '1px solid',
    borderColor: 'divider',
    bgcolor: 'background.default',
    boxShadow: 'none',
}

export const FORM_IMAGE_PREVIEW_FRAME_SX = {
    width: '100%',
    height: { xs: 220, md: 280 },
    borderRadius: `${adminRadii.control}px`,
    border: '1px solid',
    borderColor: adminBorders.subtle,
    backgroundColor: 'background.default',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}

export const getFormChoiceCardSx = (selected, disabled = false) => ({
    m: 0,
    p: 1.5,
    alignItems: 'flex-start',
    borderRadius: `${adminRadii.control}px`,
    border: '1px solid',
    borderColor: selected ? 'primary.main' : adminBorders.subtle,
    bgcolor: selected ? adminColors.blueHover : 'background.paper',
    boxShadow: selected ? `inset 0 0 0 1px ${adminColors.blueSelected}` : 'none',
    transition: `border-color ${adminTransitions.fast}, background-color ${adminTransitions.fast}, box-shadow ${adminTransitions.fast}`,
    opacity: disabled ? 0.52 : 1,
    '&:hover': {
        borderColor: disabled ? adminBorders.subtle : selected ? 'primary.main' : adminBorders.strong,
    },
    '& .MuiRadio-root': {
        mt: -0.25,
    },
    '& .MuiFormControlLabel-label': {
        width: '100%',
    },
})
